(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("learningPathVersionStorefrontPricing", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/learningPaths/version/storefrontConfig/learningPathVersionStorefrontPricingView.html",
            controller: ["$stateParams", "iso4217", "frameworkService", "learningPathVersionStorefrontResource", "messageService", "_", LearningPathVersionStorefrontPricingCtrl],
            controllerAs: "vm"
        };
        function LearningPathVersionStorefrontPricingCtrl($stateParams, iso4217, frameworkService, learningPathVersionStorefrontResource, messageService, _) {
            var vm = this;
            vm.showErrors = false;
            vm.saving = false;
            vm.loading = true;
            vm.currencySymbol = iso4217.getCurrencyByCode(frameworkService.data.storefrontCurrency).symbol;
            vm.model = learningPathVersionStorefrontResource.getPricing({ number: $stateParams.number, version: $stateParams.version }, function () {
                vm.loading = false;
            });
            vm.checkTiers = function () {
                if (!vm.model.tierPrices)
                    return false;
                return _.some(vm.model.tierPrices, function (tier) {
                    return tier.price > vm.model.price;
                });
            };
            vm.updateTiers = function () {
                if (!vm.model.tierPrices)
                    return;
                for (var idx in vm.model.tierPrices) {
                    if (vm.model.tierPrices.hasOwnProperty(idx)) {
                        if (!vm.model.tierPrices[idx].hasPercentage)
                            continue;
                        vm.model.tierPrices[idx].price = vm.model.price * (100 - vm.model.tierPrices[idx].percentage) / 100;
                        vm.model.tierPrices[idx].overridePercentage = false;
                    }
                }
            };
            vm.updateTier = function (tier) {
                if (!tier.hasPercentage)
                    return;
                tier.price = vm.model.price * (100 - tier.percentage) / 100;
            };
            vm.save = function () {
                if (vm.saving)
                    return;
                if (vm.form.$valid) {
                    vm.saving = true;
                    vm.model = learningPathVersionStorefrontResource.savePricing(vm.model, function () {
                        vm.saving = false;
                        messageService.success("learningPath.storefront.savePathPricing");
                    }, function (error) {
                        messageService.error(error);
                        vm.saving = false;
                    });
                }
                else {
                    vm.showErrors = true;
                }
            };
        }
    });
}());
